import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://www.compcleared.com';
const DEFAULT_DESCRIPTION = 'CompCleared helps California employers organize separate SB 553 workplace-violence and harassment-training record workflows.';

const PAGE_METADATA = {
    '/': {
        title: 'CompCleared - California Workplace Compliance Records',
        description: DEFAULT_DESCRIPTION
    },
    '/exposure-check': {
        title: 'Free SB 553 Readiness Check | CompCleared',
        description: 'Answer five educational questions to identify California workplace violence prevention topics your business may want to review.'
    },
    '/pricing': {
        title: 'CompCleared Pricing | $19 Monthly or $149 Annually',
        description: 'Simple pricing for separate California SB 553 workplace-violence and harassment-training administrative record workflows.'
    },
    '/property-management': {
        title: 'California Workplace Records for Property Managers | CompCleared',
        description: 'A practical workspace for California property-management teams organizing separate SB 553 and harassment-training administrative records.'
    },
    '/resources': {
        title: 'SB 553 Resources for California Employers | CompCleared',
        description: 'Plain-English educational guides about California workplace violence prevention plans, training, incident logs, and record organization.'
    },
    '/about': {
        title: 'About CompCleared',
        description: 'Learn why CompCleared is building practical workplace violence prevention record-organization tools for California small businesses.'
    },
    '/contact': {
        title: 'Contact CompCleared',
        description: 'Contact CompCleared for product, billing, or support questions.'
    }
};

const setMetaContent = (selector, value) => {
    const element = document.head.querySelector(selector);
    if (element) element.setAttribute('content', value);
};

function SiteMetadata() {
    const { pathname } = useLocation();

    useEffect(() => {
        const metadata = PAGE_METADATA[pathname] || {
            title: 'CompCleared',
            description: DEFAULT_DESCRIPTION
        };
        const canonicalUrl = `${SITE_URL}${pathname === '/' ? '/' : pathname}`;

        document.title = metadata.title;
        setMetaContent('meta[name="description"]', metadata.description);
        setMetaContent('meta[property="og:title"]', metadata.title);
        setMetaContent('meta[property="og:description"]', metadata.description);
        setMetaContent('meta[property="og:url"]', canonicalUrl);
        setMetaContent('meta[name="twitter:title"]', metadata.title);
        setMetaContent('meta[name="twitter:description"]', metadata.description);

        const canonical = document.head.querySelector('link[rel="canonical"]');
        if (canonical) canonical.setAttribute('href', canonicalUrl);
    }, [pathname]);

    return null;
}

export default SiteMetadata;
